import classNames from 'classnames'
import { useRouter } from 'next/router'
import React, { useEffect, useState } from 'react'
import { EXTERNAL } from '../../components/review/Constant'
import { GTM_CLICK_EVENT, getEventUserType, sendGTMCustomClickEvent } from '../../helpers/gtmHelper'
import { useCurrentUser } from '../../modules/context/UserContext'
import LinkLocale from '../../modules/i18n/LinkLocale'
import { s_lesson_review } from '../../modules/i18n/strings/auto/wording'
import useTranslation from '../../modules/i18n/useTranslation'
import { ICON_ARROW_RIGHT_PRIMARY } from '../../modules/svg/svg'
import urls from '../../modules/urls'
import { ROLE_STUDENT } from '../../modules/vars'
import Button from '../_legacy/Button'

export const CONTENT_SUB_NAV_BAR_HEIGHT = 52
interface ContentNavBarSubType {
  isMaterial?: boolean
  isPrestudy?: boolean
  isLanding?: boolean
  activeKey?: string | number
  setActiveKey?: any
  activeKey2?: string | number
  setActiveKey2?: any
  tabs?: any
  rightTabs?: any
  isReview?: boolean
  lessonId?: any
  onClickTab?: any
}
const ContentNavBarSub: React.FC<ContentNavBarSubType> = ({
  isLanding = false,
  tabs,
  activeKey,
  setActiveKey,
  rightTabs,
  isReview,
  lessonId,
  onClickTab,
}) => {
  const { t, locale } = useTranslation()
  const router = useRouter()
  const { currentUser } = useCurrentUser()

  const handleClickTab = (item) => {
    if (currentUser.role == ROLE_STUDENT) {
      sendGTMCustomClickEvent(
        GTM_CLICK_EVENT.CLICK_CLASSROOM_TAB,
        item.key,
        item.label,
        getEventUserType(currentUser),
        '수업/예습 페이지',
        router.asPath
      )
    }
    setActiveKey(item.key)
    onClickTab && onClickTab(item.key)
  }

  const [isMobile, setIsMobile] = useState(true)

  useEffect(() => {
    if (window.screen.width < window.innerWidth) {
      setIsMobile(window.screen.width < 576)
    } else {
      setIsMobile(window.innerWidth < 576)
    }
  }, [])

  return (
    <>
      <div
        style={{ height: CONTENT_SUB_NAV_BAR_HEIGHT }}
        className={classNames(
          { 'overflow-x-scroll': rightTabs || isMobile },
          { 'px-[20px]': !isMobile },
          { 'px-[10px]': isMobile },
          { fixed: !rightTabs },
          { 'w-screen': !rightTabs },
          { 'top-[70px]': isLanding && !isMobile },
          { 'top-[50px]': isMobile },
          { 'z-50': !isMobile },
          { 'z-30': isMobile },
          'no-scrollbar noscroll left-[0px] cursor-pointer overflow-y-hidden border-b bg-white shadow-sm'
        )}
      >
        <div className="flex">
          <div style={{ height: CONTENT_SUB_NAV_BAR_HEIGHT }} className="flex items-center">
            {tabs
              .filter((item) => item.none != true)
              .map((item, i) => (
                <div data-ref={item?.dataRef} key={i} onClick={() => handleClickTab(item)}>
                  <div
                    style={{ height: CONTENT_SUB_NAV_BAR_HEIGHT }}
                    className={classNames(
                      { 'mx-[16px]': item.key !== EXTERNAL, 'flex-row': !!item.icon },
                      'relative flex pb-[14px] pt-[12px]'
                    )}
                  >
                    <div
                      className={classNames(
                        [item.key == activeKey ? 'text-black' : 'text-gray-500'],
                        'whitespace-nowrap'
                      )}
                    >
                      {item.label}
                    </div>
                    {item.key !== EXTERNAL && item.key == activeKey && (
                      <div
                        style={{ transform: 'translateX(-50%)' }}
                        className="transfrom absolute bottom-[0px] left-1/2 h-[3px] w-full bg-black"
                      ></div>
                    )}
                    {!!item.icon && (
                      <div className="ml-[4px] mb-[2px] flex items-center">
                        <item.icon />
                      </div>
                    )}
                  </div>
                </div>
              ))}
            {isReview && (
              <>
                <LinkLocale
                  href={urls.student.portal.lessons.preparation.href}
                  as={urls.student.portal.lessons.preparation.as(lessonId)}
                >
                  <a target="_blank" className="ml-[36px]">
                    <Button chipMd py6 px10 outlined>
                      <div className="flex items-center text-[14px]">
                        {t(s_lesson_review.options.study.title)}
                        <img className="ml-4 inline max-w-none" width={12} height={12} src={ICON_ARROW_RIGHT_PRIMARY} />
                      </div>
                    </Button>
                  </a>
                </LinkLocale>
              </>
            )}
          </div>
        </div>
      </div>
      <div className={classNames([isLanding && 'h-[0px]', !rightTabs && 'h-[50px]'])} />
    </>
  )
}

export default ContentNavBarSub

type RightTabsPropsType = {
  rightTabs: any
  activeKey2: any
  setActiveKey2: any
}

export const RightTabs = ({ rightTabs, activeKey2, setActiveKey2 }: RightTabsPropsType) => {
  return (
    <>
      <div
        className={classNames(
          { fixed: !rightTabs },
          'top-[70px] left-[0px] z-[60] h-[50px] cursor-pointer border-b bg-white px-[20px] shadow-sm'
        )}
      >
        <div className="flex">
          <div className="flex h-[50px] items-center">
            <div className="flex">
              {rightTabs
                .filter((item) => item.none != true)
                .map((item, i) => (
                  <div key={i} className="relative mx-[16px] h-[50px] pb-[14px] pt-[12px]">
                    <div
                      onClick={() => setActiveKey2(item.key)}
                      className={classNames(
                        [item.key == activeKey2 ? 'text-black' : 'text-gray-500'],
                        'whitespace-nowrap'
                      )}
                    >
                      {item.label}
                    </div>
                    {item.key !== EXTERNAL && item.key == activeKey2 && (
                      <div
                        style={{ transform: 'translateX(-50%)' }}
                        className="transfrom absolute bottom-[0px] left-1/2 h-[3px] w-full bg-black"
                      ></div>
                    )}
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      <div className={classNames({ 'h-[50px]': !rightTabs })} />
    </>
  )
}
